



















import Vue from 'vue'
import {Component, Inject} from 'vue-property-decorator'
import {Observer} from 'mobx-vue'
import PerfectScrollbar from 'perfect-scrollbar'

import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import {RootStore} from '../../../stores/RootStore'
import { NewsStore } from '../../../stores/News'

import Skeleton from '../../skeleton/Skeleton.vue'


@Observer
@Component({components: {
    RecycleScroller,
    Skeleton
}})
export default class CommunityNews extends Vue {
    @Inject()
    private readonly rootStore!: RootStore

    news!: NewsStore

    created() {
        this.news = this.rootStore.news
    }

    mounted() {
        this.news.load()
    }
}
